"use client"

import type React from "react"
import { memo } from "react"
import type { PlatformConnection } from "../../../types/field-mapping"

interface PlatformCardProps {
  platform: "hubspot" | "salesforce"
  connection: PlatformConnection
  onConnect: () => void
  onDisconnect: () => void
  loading: boolean
  disabled?: boolean
}

const PlatformCard: React.FC<PlatformCardProps> = memo(
  ({ platform, connection, onConnect, onDisconnect, loading, disabled = false }) => {
    const platformConfig = {
      hubspot: {
        name: "HubSpot",
        logo: "https://cdn.worldvectorlogo.com/logos/hubspot-1.svg",
        className: "hubspot-logo",
      },
      salesforce: {
        name: "Salesforce",
        logo: "https://cdn.worldvectorlogo.com/logos/salesforce-2.svg",
        className: "salesforce-logo",
      },
    }

    const config = platformConfig[platform]

    return (
      <div className="platform-card">
        <div className="platform-header">
          <div className={`platform-logo ${config.className}`}>
            <img src={config.logo || "/placeholder.svg"} alt={config.name} />
          </div>
          <h3>{config.name}</h3>
        </div>

        <div className="connection-status">
          <div className={`status-indicator ${connection.connected ? "connected" : "disconnected"}`}>
            {connection.connected ? "✓" : "○"}
          </div>
          <span className="status-text">{connection.connected ? "Connected" : "Not Connected"}</span>
        </div>

        {connection.error && (
          <div className="error-message">
            <span>⚠️ {connection.error}</span>
          </div>
        )}

        <div className="connection-actions">
          <button
            className={`connect-button ${connection.connected ? "connected" : disabled ? "disabled" : platform}`}
            onClick={connection.connected ? onDisconnect : onConnect}
            disabled={disabled || loading}
          >
            {connection.connected ? "Disconnect" : "Connect"}
          </button>
        </div>

        {connection.connected && connection.tenantId && (
          <div className="tenant-info">
            <small>Tenant ID: {connection.tenantId}</small>
          </div>
        )}
      </div>
    )
  },
)

PlatformCard.displayName = "PlatformCard"

export default PlatformCard
